<div class="left-menu-bg" [ngStyle]="{'height': innerHeight}" [ngClass]="{'show': navbarMobileService.show}">
    <div class="left-menu" >
        <app-user-menu-mobile></app-user-menu-mobile>
        <!-- <app-main-link-menu></app-main-link-menu> -->
    </div>
    <!-- <div class="right-menu" (click)="navbarMobileService.show = false">

    </div> -->
</div>
